"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, type ReactNode, use, useMemo } from "react";
import { mediaIdFromReference } from "../../runtime/mediaIdFromReference";
export type DynamicImageMediaSource = {
  authorImageUrl: string | null;
  featuredMediaId: string | null;
  userImageUrl: string | null;
};
const EMPTY_SOURCE: DynamicImageMediaSource = {
  authorImageUrl: null,
  featuredMediaId: null,
  userImageUrl: null
};
const DynamicImageMediaContext = createContext<DynamicImageMediaSource>(EMPTY_SOURCE);
export function DynamicImageMediaProvider(t0) {
  const $ = _c(13);
  const {
    authorImageUrl,
    children,
    featuredMediaId,
    userImageUrl
  } = t0;
  let t1;
  if ($[0] !== authorImageUrl) {
    t1 = authorImageUrl?.trim() || null;
    $[0] = authorImageUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== featuredMediaId) {
    t2 = featuredMediaId?.trim() || null;
    $[2] = featuredMediaId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== userImageUrl) {
    t3 = userImageUrl?.trim() || null;
    $[4] = userImageUrl;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = {
      authorImageUrl: t1,
      featuredMediaId: t2,
      userImageUrl: t3
    };
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const value = t4;
  let t5;
  if ($[10] !== children || $[11] !== value) {
    t5 = <DynamicImageMediaContext.Provider value={value}>{children}</DynamicImageMediaContext.Provider>;
    $[10] = children;
    $[11] = value;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
export function useDynamicImageMedia(): DynamicImageMediaSource {
  return use(DynamicImageMediaContext);
}
export function dynamicImageMediaId(binding: "featured" | "author" | "user", source: {
  authorImageUrl?: string | null;
  featuredImageUrl?: string | null;
  featuredMediaId?: string | null;
  userImageUrl?: string | null;
}): string | null {
  if (binding === "featured") {
    return mediaIdFromReference(source.featuredMediaId) ?? mediaIdFromReference(source.featuredImageUrl);
  }
  if (binding === "author") {
    return mediaIdFromReference(source.authorImageUrl);
  }
  return mediaIdFromReference(source.userImageUrl);
}